import { useLocalStorage } from "@/hooks/use-local-storage";

// v2: the duplicate-account check is opt-in now (it fires a second full search
// query on every keystroke-committed search, and most lookups don't need it).
//
// The key is versioned deliberately. useLocalStorage WRITES its default on
// first read, so everyone who has already opened the Users page has `true`
// persisted under the v1 key — a stored value wins over the default forever, so
// flipping the default alone would leave every existing user opted in. Reading
// from a fresh key is what actually turns it off for them once; anyone who
// re-enables it still keeps that choice.
const DUPLICATE_SEARCH_KEY = "rh_ops_duplicate_search_enabled_v2";

export function useDuplicateSearchSetting() {
  const [enabled, setEnabled] = useLocalStorage<boolean>(
    DUPLICATE_SEARCH_KEY,
    false
  );
  return { enabled, setEnabled };
}
